import { render, staticRenderFns } from "./segmentDetails.vue?vue&type=template&id=8c66c8da&"
import script from "./segmentDetails.vue?vue&type=script&lang=js&"
export * from "./segmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./segmentDetails.vue?vue&type=style&index=0&id=8c66c8da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports